const t = await i18next.init({
  lng: "pt",
  resources: {
    pt: {
      translation: {
        heading_female: "Plano de longevidade da {{name}}",
        heading_male: "Plano de longevidade do {{name}}",
        subtitle_female:
          "Reunimos todas as respostas que nos deste e calculámos o plano perfeito para a {{name}}.",
        subtitle_male:
          "Reunimos todas as respostas que nos deste e calculámos o plano perfeito para o {{name}}.",
        why_label_female: "Porque este plano é ideal para a {{name}}",
        why_label_male: "Porque este plano é ideal para o {{name}}",
        what_label_description: "Porque este plano é ideal para o {{name}}",
        impact_label_description: "Porque este plano é ideal para o {{name}}",
      },
    },
  },
});

const { name, gender } = QuizStorage.getQuizAnswers();
document.querySelector(".plan-section .plan-heading").textContent = t(
  "heading",
  {
    context: gender,
    name,
  },
);

document.querySelector(
  ".plan-section .plan-subtitle-row .plan-subtitle",
).textContent = t("subtitle", {
  context: gender,
  name,
});

document.querySelector(".why-banner .why-label").textContent = t("why_label", {
  context: gender,
  name,
});
